import {
  takeLatest, all, call, put, select, delay,
} from 'redux-saga/effects';

import { notification } from '@anna/anna-ws-ui';
import {
  apiRequestZip,
  apiRequestZipCheckStatus,
} from './api';

import {
  requestZipActionTypes,
  requestZipActions,
  requestZipCheckStatusActions,
  requestZipCheckStatusActionTypes,
  downloadZipActions,
  downloadZipActionTypes,
} from './actions';

function* requestZip() {
  try {
    yield put(requestZipActions.request());

    const accountId = yield select((state) => state.accountService.account.id);
    const dates = yield select((state) => state.transactionsService.dates);
    const companyId = yield select((state) => state.appService.companyId);

    const response = yield call(() => apiRequestZip(companyId, accountId, dates));
    const responseJson = yield response.json();
    yield put(requestZipActions.success(responseJson.data.id));
  } catch (error) {
    console.error(error);
    yield put(requestZipActions.error(error));
  }
}

function* requestZipCheckStatus() {
  try {
    yield put(requestZipCheckStatusActions.request());

    const accountId = yield select((state) => state.accountService.account.id);
    const requestId = yield select((state) => state.downloadZipService.requestId);
    const companyId = yield select((state) => state.appService.companyId);

    const response = yield call(() => apiRequestZipCheckStatus(companyId, accountId,
      requestId));
    const responseJson = yield response.json();
    if (responseJson.data.status === 'ready') {
      const fileUrl = responseJson.data.direct_url;
      yield put(downloadZipActions.common(fileUrl));
    } else if (responseJson.data.status === 'failed') {
      notification.error('Can’t download file.');
      yield put(downloadZipActions.error());
    } else {
      yield delay(2000);
      yield put(requestZipCheckStatusActions.common());
    }
    yield put(requestZipCheckStatusActions.success());
  } catch (error) {
    console.error(error);
    yield put(requestZipCheckStatusActions.error(error));
  }
}

function* downloadZip(action) {
  try {
    yield put(downloadZipActions.request());

    const { downloadUrl } = action;
    window.location.href = downloadUrl;

    yield put(downloadZipActions.success());
  } catch (error) {
    console.error(error);
    yield put(downloadZipActions.error(error));
  }
}

function* watchRequestZip() {
  yield takeLatest(requestZipActionTypes.common, requestZip);
}

function* watchRequestZipCheckStatus() {
  yield takeLatest(requestZipCheckStatusActionTypes.common, requestZipCheckStatus);
}

function* watchDownloadZip() {
  yield takeLatest(downloadZipActionTypes.common, downloadZip);
}

export default function* root() {
  yield all([
    watchRequestZip(),
    watchRequestZipCheckStatus(),
    watchDownloadZip(),
  ]);
}
